export default __webpack_public_path__ + "static/media/teucrium.74510519.png";